import saleTokenAddress from "../context/contractsData/SaleToken-address.json";

export const BRAND = {
  name: "1EYE Chain",
  tokenName: "1EYE",
  tokenSymbol: "1EYE",
  tagline: "1EYE Chain Powered by AI",
  domain: "https://1eyechain.network",
  contactEmail: "support@1eyechain.network",
  logoPath: "/images/1eyechain-logo.png",
  logoPathLight: "/images/1eyechain-logo-white.png",
  whitepaperUrl: "/white_paper.pdf",
  auditUrl: "/audit_report.pdf",
  tokenAddress: saleTokenAddress.address,
  tokenDecimals: 18,
  totalSupply: "1_000_000_000",
  chainName: "Binance Smart Chain",
  tokenPriceLabel: "1 1EYE = 0.05 USDT",
  assetName: "1EYE",
  socialLinks: {
    instagram: "https://www.instagram.com/1eyechain.network",
    x: "https://x.com/1eyechain?s=11",
    // coinMarketCap: "#",
    discord: "https://discord.gg/rRJE9Zp3X",
    // medium: "#",
    telegram: "https://t.me/oneeyechainnetwork",
    tiktok: "https://www.tiktok.com/@1eyecser6ei?_r=1&_t=ZS-97tnpWEQgwG",
  },
};
